export function generate() {
    window.location.href = getBaseUrl();
}
export function getBaseUrl() {
    return window.location.href.split('?')[0];
}
export function getUrlWithHash(_hash) {
    return getBaseUrl() + '?hash=' + _hash;
}
